import { FC, useEffect } from 'react';
import { MdClose } from 'react-icons/md';
import ModalComponent from 'components/modal/ModalComponent';
import MapComponentStores from '../MapComponentStores';
import { usePurchases } from '@/stores/support-page/purchase';
import { retailerStore } from '@/stores/map/retailProductsStore';
import { ChannelsightSlider } from '@/components/Channelsight/slider';
import { AutoSroll } from '@/components/AutoScroll';

interface ModalMapProps {
  setMapOpen: (value: boolean) => void;
  mapOpen: boolean;
}

const ModalMap: FC<ModalMapProps> = ({ setMapOpen, mapOpen }) => {
  const { _hasHydrated, retailerProducts } = retailerStore();
  const { getPurchases } = usePurchases();

  useEffect(() => {
    getPurchases({ params: '' });
  }, [getPurchases]);

  return (
    <ModalComponent
      containerClass='mb-10h-[calc(100vh-14rem)]'
      size='2xl'
      isOpen={mapOpen}
      close={() => setMapOpen(false)}
    >
      <div className='flex flex-col'>
        <div className='flex w-full flex-row justify-between p-4'>
          <div>
            {_hasHydrated && retailerProducts && (
              <>
                <p className='retailers-subtitle text-sm text-gray-500 sm:text-base'>
                  Showing results for: {retailerProducts.ProductName}
                </p>
                <p className='retailers-subtitle text-sm text-gray-500 sm:text-base'>
                  Model #: {retailerProducts.ProductId}
                </p>
              </>
            )}
          </div>
          <div className='flex justify-end'>
            <button
              className='items-top justify-top flex rounded-lg'
              onClick={() => setMapOpen(false)}
            >
              <MdClose className='size-4 text-inherit' />
            </button>
          </div>
        </div>
        {_hasHydrated && retailerProducts ? (
          <ChannelsightSlider />
        ) : (
          <AutoSroll />
        )}
        <MapComponentStores />
      </div>
    </ModalComponent>
  );
};

export default ModalMap;
